/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-24T16:23:29.436
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'financial-FinancialPayment-'

export default 
{
path: '/financial/financialpayment',
name: 'financial-FinancialPayment',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}FinancialPayment-index',

meta:{
...meta,
title: '应收管理'
},

component: () => import('@/pages/financial/financialpayment/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}FinancialPayment-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收管理编辑'
},

component: () => import('@/pages/financial/financialpayment/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}FinancialPaymentdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收管理新增'
},

component: () => import('@/pages/financial/financialpayment/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}FinancialPaymentView',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收管理详情查看'
},

component: () => import('@/pages/financial/financialpayment/detail-view') ,
},
]
};
